export enum SignupErrorReason {
  GENERIC = "0",
  DOMAIN_CONSTRAINT = "1",
  SINGLE_TENANT = "2",
  INVITE_LINK = "3",
  MAX_SIGNUPS = "4",
}
